import { DatePicker } from '@mui/lab';
import { Grid, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { FilterResearchAmountVM, ResearchAmountVM } from 'front-office/view-models/research-amount';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchAmountVM>();

  const onChange = useEventCallback(
    (
      key: keyof FilterResearchAmountVM,
      value: FilterResearchAmountVM[keyof FilterResearchAmountVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Codice importo"
          aria-label="Codice importo"
          fullWidth
          id="code"
          name="code"
          value={formContext.values?.filter?.code || ''}
          onChange={(event) => onChange('code', event.target.value)}
          inputProps={{
            maxLength: '4',
          }}
          helperText={(formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.code}
          error={
            (formContext.touched.filter as FormikTouched<FilterResearchAmountVM>)?.code &&
            Boolean((formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.code)
          }
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Descrizione importo"
          aria-label="Descrizione importo"
          fullWidth
          id="description"
          name="description"
          value={formContext.values?.filter?.description || ''}
          onChange={(event) => onChange('description', event.target.value)}
          inputProps={{
            maxLength: '50',
          }}
          helperText={
            (formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.description
          }
          error={
            (formContext.touched.filter as FormikTouched<FilterResearchAmountVM>)?.description &&
            Boolean(
              (formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.description
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data inizio validità"
          aria-label="Data inizio validità"
          value={formContext.values?.filter?.dateFrom || null}
          onChange={(value) => onChange('dateFrom', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateFrom"
              name="dateFrom"
              helperText={
                (formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.dateFrom
              }
              error={
                (formContext.touched.filter as FormikTouched<FilterResearchAmountVM>)?.dateFrom &&
                Boolean(
                  (formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.dateFrom
                )
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data fine validità"
          aria-label="Data fine validità"
          value={formContext.values?.filter?.dateTo || null}
          onChange={(value) => onChange('dateTo', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateTo"
              name="dateTo"
              helperText={
                (formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.dateTo
              }
              error={
                (formContext.touched.filter as FormikTouched<FilterResearchAmountVM>)?.dateTo &&
                Boolean((formContext.errors.filter as FormikErrors<FilterResearchAmountVM>)?.dateTo)
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Lots Management List - Filter - Form';

export default FormFilter;
